import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import LeadDetails from "./lead-details";

function ProviderLeadDetailsWrapper() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <LeadDetails
      leadId={Number(id)}
      onBack={() => navigate(-1)}
    />
  );
}
export default ProviderLeadDetailsWrapper;